var _mask, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_14656_42531",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 44,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 42,
    height: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.95431 9.95431 1 21 1C32.0457 1 41 9.95431 41 21C41 32.0457 32.0457 41 21 41C9.95431 41 1 32.0457 1 21Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.95431 9.95431 1 21 1C32.0457 1 41 9.95431 41 21C41 32.0457 32.0457 41 21 41C9.95431 41 1 32.0457 1 21Z",
    fill: "#90A8C1",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21H40C40 10.5066 31.4934 2 21 2C10.5066 2 2 10.5066 2 21H0ZM42 23C42 34.598 32.598 44 21 44C9.40202 44 0 34.598 0 23L2 21C2 30.3888 10.5066 38 21 38C31.4934 38 40 30.3888 40 21L42 23ZM21 44C9.40202 44 0 34.598 0 23V21C0 9.40202 9.40202 0 21 0V2C10.5066 2 2 10.5066 2 21C2 30.3888 10.5066 38 21 38V44ZM21 0C32.598 0 42 9.40202 42 21V23C42 34.598 32.598 44 21 44V38C31.4934 38 40 30.3888 40 21C40 10.5066 31.4934 2 21 2V0Z",
    fill: "#90A8C1",
    fillOpacity: 0.3,
    mask: "url(#path-1-outside-1_14656_42531)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.171 30.3307H11.8264C10.4485 30.3307 9.33203 29.2142 9.33203 27.8364V14.1584C9.33203 12.7806 10.4485 11.6641 11.8264 11.6641H30.171C31.5489 11.6641 32.6654 12.7806 32.6654 14.1584V27.8364C32.6654 29.2142 31.5489 30.3307 30.171 30.3307Z",
    stroke: "#FAFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2455 29.2375L24.2422 22.0625",
    stroke: "#FAFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7889 22.1172L9.86719 29.3739",
    stroke: "#FAFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60156 13.0547L19.6 22.5853C20.3804 23.3293 21.61 23.3207 22.38 22.5659L32.0827 13.0547",
    stroke: "#FAFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareEmail);
export default __webpack_public_path__ + "static/media/ShareEmail.98f7f4cd3cc6444fdc27ab1c084a66b6.svg";
export { ForwardRef as ReactComponent };